/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pitch_Ai_TitleInputs */



/**
* | output |
* | --- |
* | "AI as suggestions" |
*
* @param {Pitch_Ai_TitleInputs} inputs
* @param {{ locale?: "nb-NO" | "en-GB" | "sv-SE" }} options
* @returns {LocalizedString}
*/
export const pitch_ai_title = /** @type {((inputs?: Pitch_Ai_TitleInputs, options?: { locale?: "nb-NO" | "en-GB" | "sv-SE" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pitch_Ai_TitleInputs, { locale?: "nb-NO" | "en-GB" | "sv-SE" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return /** @type {LocalizedString} */ ("AI as suggestions")
	if (locale === "sv-SE") return /** @type {LocalizedString} */ ("AI som förslag")
	return /** @type {LocalizedString} */ ("KI som forslag")
});